// Delegated listener also handles controls replaced by Horizon's section renderer.
document.addEventListener('change', (event) => {
  const picker = event.target;
  if (!(picker instanceof HTMLSelectElement) || !picker.matches('[data-cs-collection-picker]')) return;
  event.stopPropagation();
  const destination = new URL(picker.value, window.location.origin);
  if (destination.origin !== window.location.origin) return;
  const sortBy = new URL(window.location.href).searchParams.get('sort_by');
  if (sortBy) destination.searchParams.set('sort_by', sortBy);
  window.location.assign(destination.href);
}, { capture: true });
